<script setup lang="ts">
import { useHead } from '@unhead/vue';
import Divider from '@/layout/Divider.vue';
import Layout from '@/layout/Layout.vue';

useHead({
  title: "Albano's Villa | Employment",
  meta: [
    {
      name: 'description',
      content:
        "Join the Albano's Villa team — now accepting applications for pasta cook, pizza cook and front-house positions. Download the application to apply.",
    },
  ],
});
</script>

<template>
  <Layout sidebar="images-employment">
    <h1>Come Join the Fun!</h1>
    <p>
      Albano's Villa is always accepting applications for friendly, hard-working, self-motivated
      individuals.
    </p>
    <p>
      If you handle the pressure of a fast-paced environment well, have good communications skills,
      the ability to follow through with instructions and are able to lift 50 pounds, we'd like to
      hear from you! You must be available to work evenings during weekdays and weekends.
    </p>
    <h2>Positions:</h2>
    <ul class="list-disc pb-10 pl-20">
      <li>PASTA COOK</li>
      <li>PIZZA COOK</li>
      <li>FRONT HOUSE*</li>
    </ul>
    <p>*Strong math skills required.</p>
    <div class="py-20 text-center">
      <a href="/pdfs/employment-application.pdf" class="btn">Download Application (PDF)</a>
    </div>
    <p>Drop off your completed application at any of our locations.</p>
    <Divider />
  </Layout>
</template>
